const projectdata=[
  {
    "image":[{"img":<i className="fa-brands fa-html5 fa-2xl mx-2 my-4" style={{color: '#e83211'}}></i>,
    "subtitle":"HTML"},
    {"img": <i className="fa-brands fa-css3 fa-2xl mx-2 my-4" style={{color: '#3666ba'}}></i>,
    "subtitle":"CSS"
    },{"img":<i className="fa-brands fa-js fa-2xl mx-2 my-4" style={{color: '#df5f34'}}></i>,
  "subtitle":"JavaScript"},{"img":<i className="fa-brands fa-react fa-2xl mx-2 my-4" style={{color: '#3cb3c3'}}></i>,
"subtitle":"React"}],
    "title":"Chatting Web Application",
    "duration":"Dec. 2023 - Jan. 2024",
    "body":"Create a dynamic real-time chatting app with React, Node.js, MongoDB, and Socket.io. Utilize React for the frontend, Node.js for the server, MongoDB for data storage, and Socket.io for seamless, instant communication between users.Create a dynamic real-time chatting app with React, Node.js, MongoDB, and Socket.io. Utilize React for the frontend, Node.js for the server, MongoDB for data storage, and Socket.io for seamless, instant communication between users.",
    "projectlink":"https://chatting-app-frontend-five.vercel.app/",
    "user_id":1

  },
    {
        "image":[ {"img":<i className="fa-brands fa-html5 fa-2xl mx-2 my-4" style={{color: '#e83211'}}></i>,
                    "subtitle":"HTML"},
            {"img": <i className="fa-brands fa-css3 fa-2xl mx-2 my-4" style={{color: '#3666ba'}}></i>,
            "subtitle":"CSS"
            },{"img":<i className="fa-brands fa-php fa-2xl mx-2 my-4"></i>,
          "subtitle":"PhP"},
        {"img":<i className="fa-brands fa-js fa-2xl mx-2 my-4" style={{color: '#df5f34'}}></i>,
      "subtitle":"JavaScript"}],
        "title": "Hospital Management System",
        "duration":"Feb. 2023 - April 2023",
        "body":"Hospital Management System (HMS) streamlines appointments, enabling remote booking, doctor availability checks, and online payments. It boosts administrative efficiency, benefiting patients and healthcare providers alike. An indispensable tool for diverse healthcare facilities, HMS enhances the overall healthcare experience and operational effectiveness.",
        "projectlink":"https://github.com/pintu1609/hospital-management-system",
        "user_id":2
      },
     
      {
        "image":[{"img":<i className="fa-brands fa-html5 fa-2xl mx-2 my-4" style={{color: '#e83211'}}></i>,
        "subtitle":"HTML"},
        {"img": <i className="fa-brands fa-css3 fa-2xl mx-2 my-4" style={{color: '#3666ba'}}></i>,
        "subtitle":"CSS"
        },{"img":<i className="fa-brands fa-js fa-2xl mx-2 my-4" style={{color: '#df5f34'}}></i>,
      "subtitle":"JavaScript"},{"img":<i className="fa-brands fa-react fa-2xl mx-2 my-4" style={{color: '#3cb3c3'}}></i>,
    "subtitle":"React"}],
        "title":"iNotebook",
        "duration":"June 2023 - June 2023",
        "body":"iNotebook revolutionizes note-taking. Seamlessly create, edit, and manage notes for enhanced organization. This digital notepad streamlines your tasks, from jotting ideas to setting tasks. Say goodbye to clutter and hello to productivity with iNotebook.",
        "projectlink":"https://pintu-inotebook.vercel.app/login",
        "user_id":3

      },
     
        {
            "image":[{"img":<i className="fa-brands fa-react fa-2xl mx-2 my-4" style={{color: '#3cb3c3'}}></i>,
          "subtitle":"React"},{"img":<i className="fa-brands fa-js fa-2xl mx-2 my-4" style={{color: '#df5f34'}}></i>,
        "subtitle":"JavaScript"},{"img":<i className="fa-brands fa-bootstrap fa-2xl mx-2 my-4" style={{color: '#413c80'}}></i>,
      "subtitle":"Bootstrap"}],
            "title":"NewsMonkey",
            "duration":"July 2023 - July 2023",
            "body":"NewsMonkey is your go-to news app for quick, bite-sized daily updates. Whether you're passionate about current events, weather forecasts, politics, or sports news, NewsMonkey has you covered. Stay informed and up-to-date with a wide range of topics, all conveniently accessible in one app. Get your daily news fix with NewsMonkey and stay in the loop effortlessly.",
            "projectlink":"https://github.com/pintu1609/newsapp",
            "user_id":4

        },
        {
              "image":[{"img":<i className="fa-brands fa-python fa-2xl mx-2 my-4" style={{color: '#289bb8'}}></i>,
            "subtitle":"Python"},{"img":""}],
              "title":" Analytics of Indian English News Atrticle",
              "duration":"Aug. 2022 - Nov. 2022 ",
              "body":"The paper uses Recursive Neural Networks to build two classifiers: one to identify Technology Determinism or Skepticism and another for Pro or Anti Policy sentiment in media. It employs natural language processing to detect biases in media and predict sentiment, delving into complex language nuances.",
              "projectlink":"https://jmscm.smartsociety.org/volume4_issue3/paper8.pdf",
              "user_id":5
  
          },
          {
                "image":[{"img":<i className="fa-regular fa-earth-americas fa-2xl rounded-circle  mx-2 my-4" style={{color: '#45cb20'}}></i>,
              "subtitle":"Arcgis"}],
                "title":"Analysis of risk factor in Northern Indian",
                "duration":"Jan. 2023 - April 2023",
                "body":"This study investigates the interconnected dynamics of hazards, their vulnerability, and their implications on the environment, resulting in an elevated risk of fatalities. It seeks to understand the complex relationship between these factors and their consequences on human and ecological well-being.",
                "projectlink":"https://drive.google.com/file/d/1LTsznwAaFXWds1gunp7is2wvOV-FFmHR/view?usp=drive_link",
                "user_id":6
    
            },
            {
                  "image":[{"img":<i className="fa-brands fa-android fa-2xl mx-2 my-4" style={{color: '#2ab427'}}></i>,
                "subtitle":"Android Studio"}],
                  "title":"Learning App:Grader",
                  "duration":"Feb. 2022 - April 2022",
                  "body":"The Grader Android learning app enables users to take mock tests in various subjects, each containing different questions, all within a set time limit. Post-test, users can assess their scores, view leaderboard rankings, and bookmark questions for reference. Additionally, they can review correct answers to all questions, enhancing their learning experience. ",
                  "projectlink":"https://github.com/pintu1609/Learning-app-Grader",
                  "user_id":7
      
              }
              


             //dumi template
        // {
        //     "image":[{"img":<i className="fa-brands fa-react fa-2xl mx-2 my-4" style={{color: '#3cb3c3'}}></i>}],
        //     "title":"",
        //     "duration":"",
        //     "body":"",
        //     "projectlink":"",
        //     "user_id":

        // }

]
export default projectdata;